import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=cc25db6e"
import script from "./PdfView.ts?vue&type=script&lang=ts&external"
export * from "./PdfView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports